import action from '@/http/axios'
// import { CancelHttp } from '@/tools/utils'

// const cancelHttp = new CancelHttp()

export default {
  // testBaidu(data, config) {
  //   const http = action.commonPost('/api/json/data', data, config)
  //   http.mySourceKey = cancelHttp.add('testBaidu', http.mySource)
  //   return http
  // },
  quote(data, config) {
    return action.commonGet(
      process.env.VUE_APP_0X + 'swap/v1/quote',
      data,
      config
    )
  },
  tokens(config) {
    return action.commonGet(
      process.env.VUE_APP_0X + 'swap/v1/tokens',
      null,
      config
    )
  },
  send(data, config) {
    return action.commonPost(process.env.VUE_APP_RPC, data, config)
  },

  //swap
  swapQuote(params) {
    return action.commonGet(process.env.VUE_APP_0X + 'swap/v1/quote', params)
  },
  swapTokens(params) {
    return action.commonGet(process.env.VUE_APP_0X + 'swap/v1/tokens', params)
  },
  swapPrice(params) {
    return action.commonGet(process.env.VUE_APP_0X + 'swap/v1/price', params)
  },

  //coins
  coinsSimplePrice(params) {
    return action.commonGet(
      process.env.VUE_APP_COINGECKO + 'api/v3/simple/price',
      params
    )
  },
  coinsMarketChartRange(params, id) {
    return action.commonGet(
      process.env.VUE_APP_COINGECKO + `api/v3/coins/${id}/market_chart/range`,
      params
    )
  },
  coinsMarkets(params) {
    return action.commonGet(
      process.env.VUE_APP_COINGECKO + 'api/v3/coins/markets',
      params
    )
  },
  coinsMarketsContract(params) {
    return action.commonGet(
      process.env.VUE_APP_COINGECKO +
        `api/v3/coins/${params.id}/contract/` +
        params.contractAddress
    )
  },
  // price
  getGasPrice() {
    return action.commonGet('https://api-cn.etherscan.com/api', {
      module: 'gastracker',
      action: 'gasoracle',
      apikey: 'TAB47HRQZK5R9Y4Q16P9Q7CFG9SSXH2M6B'
    })
  }
}
